<div class="cv-confirmation-inactivity-component" *ngIf="isOpen">
	<div class="cv-confirmation-box">
		<div class="modal-body">
			<p class="msg-content">
                Are you still there?<br/>
                <span class="msg-general">It looks like you might have stepped away from the workspace</span>
			</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="stillThere()">Yes, I'm here</button>
		</div>
	</div>
</div>
